import React from 'react';

const Spinner = () => {
  return (
    <div className="loading">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Spinner;
